import { render, staticRenderFns } from "./ThePDP.vue?vue&type=template&id=c3db8130&"
import script from "./ThePDP.vue?vue&type=script&lang=js&"
export * from "./ThePDP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3db8130')) {
      api.createRecord('c3db8130', component.options)
    } else {
      api.reload('c3db8130', component.options)
    }
    module.hot.accept("./ThePDP.vue?vue&type=template&id=c3db8130&", function () {
      api.rerender('c3db8130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/ThePDP.vue"
export default component.exports